export const iconFontAwesomeBuildingsHospital = (
	<i className="fa-solid fa-hospital"></i>
);
